(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-claude-pdp-v1-buy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffcp-buy]').forEach(function (root) {
  var formId = root.getAttribute('data-form-id');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ffcp-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ffcp-thumb]'));
  var sticky = root.querySelector('[data-ffcp-sticky]');
  var stickyPrice = root.querySelector('[data-ffcp-sticky-price]');
  var stickyBtn = root.querySelector('[data-ffcp-sticky-btn]');
  var priceList = root.querySelector('[data-product-price-list]');

  function showMedia(id) {
    if (!id) return;
    var found = false;
    slides.forEach(function (s) {
      var on = String(s.getAttribute('data-media-id')) === String(id);
      if (on) found = true;
      s.hidden = !on;
      if (!on) { var v = s.querySelector('video'); if (v && !v.paused) { try { v.pause(); } catch (e) {} } }
    });
    if (!found) return;
    thumbs.forEach(function (t) { t.setAttribute('aria-selected', String(String(t.getAttribute('data-media-id')) === String(id))); });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showMedia(t.getAttribute('data-media-id'));
      if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  });

  function bindForm() {
    var form = document.getElementById(formId);
    if (!form) return false;
    form.addEventListener('variant:changed', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.featured_media && variant.featured_media.id) showMedia(variant.featured_media.id);
      if (stickyBtn) {
        var available = !!(variant && variant.available);
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? stickyBtn.getAttribute('data-label') : stickyBtn.getAttribute('data-soldout');
      }
      // keep any secondary product forms on the page (compare table) on the same variant
      if (variant && variant.id) {
        document.querySelectorAll('form[is="product-form"]').forEach(function (f) {
          if (f.id === formId) return;
          var idInput = f.querySelector('[name="id"]'); if (idInput) idInput.value = variant.id;
          var btn = f.querySelector('button[type="submit"]');
          if (btn && btn.classList.contains('ffcp-cmp__btn')) { btn.disabled = !variant.available; }
        });
      }
      if (stickyPrice && priceList) {
        setTimeout(function () {
          var p = priceList.querySelector('.price--highlight') || priceList.querySelector('.price');
          if (p) stickyPrice.textContent = p.textContent.replace(/\s+/g, ' ').trim();
        }, 0);
      }
    });
    return true;
  }
  if (!bindForm()) document.addEventListener('DOMContentLoaded', bindForm);

  var arLink = root.querySelector('[data-ffcp-ar]');
  if (arLink) {
    var findTarget = function () {
      var sel = arLink.getAttribute('data-ar-target');
      var t = null;
      try { t = sel ? document.querySelector(sel) : null; } catch (e) { t = null; }
      if (!t) { var href = arLink.getAttribute('href') || ''; if (href.charAt(0) === '#' && href.length > 1) { try { t = document.querySelector(href); } catch (e2) { t = null; } } }
      return t;
    };
    arLink.addEventListener('click', function (e) {
      var t = findTarget();
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    var syncAr = function () {
      if (root.getAttribute('data-ar-follow') !== 'true') return;
      var t = findTarget();
      var hide = !t || t.hidden || t.hasAttribute('hidden');
      arLink.hidden = hide;
      var note = arLink.nextElementSibling;
      if (note && note.classList.contains('ffcp-buy__ar-note')) note.hidden = hide;
    };
    document.addEventListener('variant:changed', function () { setTimeout(syncAr, 0); });
    if (document.readyState === 'complete') setTimeout(syncAr, 0); else window.addEventListener('load', function () { setTimeout(syncAr, 0); });
  }

  if (sticky && 'IntersectionObserver' in window) {
    var payment = root.querySelector('#MainPaymentContainer');
    var footer = document.querySelector('.shopify-section--footer');
    var passed = false, footerVisible = false;
    function update() {
      var mobile = window.matchMedia('(max-width: 999px)').matches;
      var show = mobile && passed && !footerVisible;
      sticky.hidden = !show;
      sticky.setAttribute('aria-hidden', String(!show));
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === payment) {
          var r = entry.target.getBoundingClientRect();
          passed = entry.intersectionRatio === 0 && r.top < 0;
        }
        if (entry.target === footer) footerVisible = entry.intersectionRatio > 0;
      });
      update();
    }, { threshold: [0, 0.01] });
    if (payment) io.observe(payment);
    if (footer) io.observe(footer);
    window.addEventListener('resize', update);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (payment) passed = payment.getBoundingClientRect().bottom < 0;
        if (footer) footerVisible = footer.getBoundingClientRect().top < window.innerHeight;
        update();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-claude-pdp-v1-space"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffcp-space]').forEach(function (root) {
  var target = root.getAttribute('data-target-variant-id');
  function sync(id) { if (!target) return; root.hidden = String(id) !== String(target); }
  document.addEventListener('variant:changed', function (e) { var v = e.detail && e.detail.variant; if (v) sync(v.id); });
  var btn = root.querySelector('[data-ffcp-space-launch]');
  if (btn) btn.addEventListener('click', async function () {
    var viewer = root.querySelector('model-viewer'); if (!viewer) return;
    if (viewer.canActivateAR && typeof viewer.activateAR === 'function') { try { await viewer.activateAR(); return; } catch (err) {} }
    viewer.scrollIntoView({ behavior: 'smooth', block: 'center' }); viewer.focus();
  });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { var mv = root.querySelector('model-viewer'); if (mv) { mv.removeAttribute('auto-rotate'); mv.removeAttribute('autoplay'); } }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-doho-3d-ar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-doho-model')) {
    customElements.define(
      'ff-doho-model',
      class extends HTMLElement {
        connectedCallback() {
          this.onVariantChanged = this.onVariantChanged.bind(this);
          this.onDohoVariantChanged = this.onDohoVariantChanged.bind(this);
          this.onLaunchModel = this.onLaunchModel.bind(this);
          this.onLaunchAr = this.onLaunchAr.bind(this);
          document.addEventListener('variant:changed', this.onVariantChanged);
          document.addEventListener('ff:doho-variant-changed', this.onDohoVariantChanged);
          this.querySelector('[data-model-launch]')?.addEventListener('click', this.onLaunchModel);
          this.querySelector('[data-model-ar-launch]')?.addEventListener('click', this.onLaunchAr);
          this.updateVisibility(this.dataset.currentVariantId);

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.querySelector('model-viewer')?.removeAttribute('auto-rotate');
          }
        }

        disconnectedCallback() {
          document.removeEventListener('variant:changed', this.onVariantChanged);
          document.removeEventListener('ff:doho-variant-changed', this.onDohoVariantChanged);
          this.querySelector('[data-model-launch]')?.removeEventListener('click', this.onLaunchModel);
          this.querySelector('[data-model-ar-launch]')?.removeEventListener('click', this.onLaunchAr);
        }

        onVariantChanged(event) {
          this.updateVisibility(event.detail?.variant?.id);
        }

        onDohoVariantChanged(event) {
          this.updateVisibility(event.detail?.variantId);
        }

        onLaunchModel() {
          const preview = this.querySelector('[data-model-preview]');
          if (preview) preview.hidden = true;
          this.querySelector('model-viewer')?.focus();
        }

        async onLaunchAr() {
          const preview = this.querySelector('[data-model-preview]');
          const viewer = this.querySelector('model-viewer');
          if (preview) preview.hidden = true;
          if (!viewer) return;

          if (viewer.canActivateAR && typeof viewer.activateAR === 'function') {
            try {
              await viewer.activateAR();
              return;
            } catch (error) {
              // Keep the interactive model available if the device declines AR.
            }
          }

          viewer.focus();
        }

        updateVisibility(variantId) {
          this.hidden = String(variantId) !== this.dataset.targetVariantId;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-home-see-it-in-space-v1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-home-space-v1')) {
    customElements.define(
      'ff-home-space-v1',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.viewer = this.querySelector('model-viewer');
          this.featureVideo = this.querySelector('video');
          this.launcher = this.querySelector('[data-ff-hsv1-ar]');

          this.launcher?.addEventListener('click', (event) => this.onLaunch(event), {
            signal: this.abortController.signal,
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.viewer?.removeAttribute('auto-rotate');
            this.featureVideo?.removeAttribute('autoplay');
            this.featureVideo?.pause();
          }
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        async onLaunch(event) {
          if (!this.viewer || !customElements.get('model-viewer')) return;
          event.preventDefault();
          this.viewer.dismissPoster?.();

          if (this.viewer.canActivateAR && typeof this.viewer.activateAR === 'function') {
            try {
              await this.viewer.activateAR();
              return;
            } catch (error) {
              // If the device declines AR, keep the interactive model available.
            }
          }

          this.viewer.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-home-shop-categories-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-shop-categories-v4')) {
    class FFShopCategoriesV4 extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const reconnecting = this.hasConnected;
        this.hasConnected = true;
        if (!reconnecting) {
          this.activeCategory = this.dataset.defaultCategory || 'surf';
          this.activeFacet = 'all';
          this.activeFacetValue = '';
          this.activeProductKey = null;
          this.selectionWasUserInitiated = false;
        }
        this.mobileQuery = window.matchMedia('(max-width: 900px)');

        this.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal });
        this.addEventListener('change', this.handleChange.bind(this), { signal: this.abortController.signal });
        this.addEventListener('keydown', this.handleKeydown.bind(this), { signal: this.abortController.signal });
        document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this), { signal: this.abortController.signal });
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange.bind(this), { signal: this.abortController.signal });

        this.syncPressed('[data-category-control]', 'categoryControl', this.activeCategory);
        this.syncFacetControls();
        this.applyVisibility(reconnecting ? this.activeProductKey : null);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get productTabs() {
        return [...this.querySelectorAll('[data-product-tab]')];
      }

      get panels() {
        return [...this.querySelectorAll('[data-product-panel]')];
      }

      handleClick(event) {
        const category = event.target.closest('[data-category-control]');
        if (category && this.contains(category)) {
          this.selectionWasUserInitiated = true;
          this.activeCategory = category.dataset.categoryControl;
          this.activeFacet = 'all';
          this.activeFacetValue = '';
          this.activeProductKey = null;
          this.syncPressed('[data-category-control]', 'categoryControl', this.activeCategory);
          this.syncFacetControls();
          this.applyVisibility();
          return;
        }

        const facet = event.target.closest('[data-facet-control]');
        if (facet && this.contains(facet)) {
          this.selectionWasUserInitiated = true;
          this.activeFacet = facet.dataset.facetControl;
          this.activeFacetValue = this.defaultFacetValue(this.activeFacet);
          this.activeProductKey = null;
          this.syncFacetControls();
          this.applyVisibility();
          return;
        }

        const chip = event.target.closest('[data-facet-chip]');
        if (chip && this.contains(chip)) {
          this.selectionWasUserInitiated = true;
          this.activeFacet = chip.dataset.facetChip;
          this.activeFacetValue = chip.dataset.facetValue || '';
          this.activeProductKey = null;
          this.syncFacetControls();
          this.applyVisibility();
          return;
        }

        const productTab = event.target.closest('[data-product-tab]');
        if (productTab && this.contains(productTab)) {
          this.selectionWasUserInitiated = true;
          this.selectProduct(productTab.dataset.productKey);
        }
      }

      handleChange(event) {
        const choice = event.target.closest('[data-variant-radio]');
        if (!choice || !this.contains(choice)) return;
        const panel = choice.closest('[data-product-panel]');
        if (!panel) return;

        const input = panel.querySelector('[data-variant-input]');
        if (input) input.value = choice.value;
        panel.querySelectorAll('[data-details-link]').forEach((link) => {
          const productBaseUrl = link.dataset.productBaseUrl;
          if (productBaseUrl) link.href = `${productBaseUrl}?variant=${encodeURIComponent(choice.value)}`;
        });
        panel.querySelectorAll('[data-price-display]').forEach((node) => {
          node.textContent = choice.dataset.price;
        });

        const available = choice.dataset.available === 'true';
        const status = panel.querySelector('[data-status]');
        if (status) {
          status.dataset.available = String(available);
          status.textContent = available ? this.dataset.inStockLabel : this.dataset.soldOutLabel;
        }
        const button = panel.querySelector('[data-add]');
        if (button) {
          button.disabled = !available;
          button.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        }
        const image = panel.querySelector('[data-detail-image]');
        if (image && choice.dataset.image) {
          image.closest('picture')?.querySelector('source')?.remove();
          image.src = choice.dataset.image;
          image.alt = choice.dataset.imageAlt || image.alt;
          image.removeAttribute('srcset');
        }
      }

      handleKeydown(event) {
        const current = event.target.closest('[role="tab"]');
        if (!current || !this.contains(current)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tablist = current.closest('[role="tablist"]');
        if (!tablist) return;
        const tabs = [...tablist.querySelectorAll(':scope > [role="tab"]')].filter((tab) => !tab.hidden && !tab.disabled);
        if (tabs.length < 2) return;

        event.preventDefault();
        const currentIndex = tabs.indexOf(current);
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        tabs[nextIndex].click();
      }

      handleBlockSelect(event) {
        const tab = event.target.closest?.('[data-product-tab]');
        if (!tab || !this.contains(tab)) return;
        this.selectionWasUserInitiated = true;
        this.activeCategory = tab.dataset.category;
        const isPartnerSurf = this.activeCategory === 'surf' && tab?.dataset.brand !== (this.dataset.defaultSurfBrand || 'formula-fun');
        this.activeFacet = isPartnerSurf ? 'brand' : 'all';
        this.activeFacetValue = isPartnerSurf ? tab.dataset.brand : '';
        this.syncPressed('[data-category-control]', 'categoryControl', this.activeCategory);
        this.syncFacetControls();
        this.applyVisibility(tab.dataset.productKey);
      }

      handleBreakpointChange() {
        this.applyVisibility(this.activeProductKey);
      }

      defaultFacetValue(facet) {
        if (facet === 'brand') {
          const partnerChips = [...this.querySelectorAll('.ff-scv4__facet-chips--desktop [data-facet-chip="brand"]')];
          const configured = this.dataset.defaultPartnerBrand || 'album';
          return partnerChips.some((chip) => chip.dataset.facetValue === configured) ? configured : (partnerChips[0]?.dataset.facetValue || '');
        }
        if (facet === 'skill') return 'first-waves';
        if (facet === 'kids') return 'kids';
        return '';
      }

      syncPressed(selector, dataKey, value) {
        this.querySelectorAll(selector).forEach((control) => {
          control.setAttribute('aria-pressed', String(control.dataset[dataKey] === value));
        });
      }

      syncFacetControls() {
        this.syncPressed('[data-facet-control]', 'facetControl', this.activeFacet);
        this.querySelectorAll('[data-facet-chip]').forEach((chip) => {
          const active = chip.dataset.facetChip === this.activeFacet && chip.dataset.facetValue === this.activeFacetValue;
          chip.setAttribute('aria-pressed', String(active));
          chip.hidden = chip.closest('[data-mobile-direct-filters]') ? false : chip.dataset.facetChip !== this.activeFacet;
        });
        this.querySelectorAll('[data-facet-chips]').forEach((group) => {
          group.hidden = this.activeFacet === 'all';
        });
      }

      matchesFacet(tab) {
        if (this.activeCategory !== 'surf') return true;
        if (this.activeFacet === 'all') return tab.dataset.brand === (this.dataset.defaultSurfBrand || 'formula-fun');
        if (this.activeFacet === 'brand') return tab.dataset.brand === this.activeFacetValue;
        if (this.activeFacet === 'skill') return tab.dataset.skill === this.activeFacetValue;
        if (this.activeFacet === 'kids') return tab.dataset.kids === 'true';
        return true;
      }

      applyVisibility(preferredKey = null) {
        this.querySelectorAll('[data-surf-filters]').forEach((group) => {
          group.hidden = this.activeCategory !== 'surf';
          group.setAttribute('aria-hidden', String(this.activeCategory !== 'surf'));
        });

        let firstVisible = null;
        let visibleCount = 0;
        const visibleTabs = [];
        this.productTabs.forEach((tab) => {
          const visible = tab.dataset.category === this.activeCategory && this.matchesFacet(tab);
          tab.hidden = !visible;
          if (visible) {
            visibleCount += 1;
            visibleTabs.push(tab);
            if (!firstVisible) firstVisible = tab;
          }
        });

        const quiverLayout = visibleTabs.length > 0 && visibleTabs.every((tab) => tab.dataset.selectorMode === 'quiver');
        const layout = quiverLayout ? 'quiver' : 'cards';
        this.dataset.layout = layout;
        this.dataset.visibleCount = String(visibleCount);
        const productList = this.querySelector('[data-product-list]');
        if (productList) {
          productList.dataset.layout = layout;
          productList.dataset.visibleCount = String(visibleCount);
          productList.style.setProperty('--ff-scv4-columns', String(Math.max(1, Math.min(visibleCount, 7))));
        }
        const lineup = this.querySelector('[data-lineup]');
        if (lineup) {
          lineup.dataset.category = this.activeCategory;
          lineup.dataset.layout = layout;
        }

        const categoryControl = this.querySelector(`[data-category-control="${this.activeCategory}"]`);
        const lineupLabel = this.querySelector('[data-current-lineup-label]');
        if (categoryControl && lineupLabel) lineupLabel.textContent = categoryControl.dataset.lineupLabel;
        if (categoryControl) this.revealCategoryControl(categoryControl);
        const mobileLabel = this.querySelector('[data-mobile-filter-label]');
        if (categoryControl && mobileLabel) mobileLabel.textContent = categoryControl.dataset.shopByLabel;

        const categoryLink = this.querySelector('[data-category-link]');
        if (categoryControl && categoryLink) {
          const collectionUrl = categoryControl.dataset.collectionUrl;
          categoryLink.textContent = categoryControl.dataset.collectionLabel;
          categoryLink.hidden = !collectionUrl;
          if (collectionUrl) categoryLink.href = collectionUrl;
        }

        const scaleNote = this.querySelector('[data-scale-note]');
        if (scaleNote) {
          const suffix = quiverLayout ? (this.dataset.trueScaleLabel || 'shown at true scale') : (this.dataset.cardCountLabel || 'current products');
          const countLabel = visibleCount === 1 ? (this.dataset.singularBoardLabel || 'board') : (this.dataset.pluralBoardLabel || 'boards');
          scaleNote.textContent = `${visibleCount} ${countLabel} · ${suffix}`;
        }

        let current = this.productTabs.find((tab) => tab.dataset.productKey === (preferredKey || this.activeProductKey) && !tab.hidden);
        const next = current || firstVisible;
        if (next) {
          this.selectProduct(next.dataset.productKey);
          if (layout === 'cards') this.alignCardListToStart(productList);
          else if (this.dataset.mobileQuiverLayout === 'scroll') this.alignProductToStart(next);
          return;
        }

        this.activeProductKey = null;
        this.productTabs.forEach((tab) => {
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = -1;
        });
        this.panels.forEach((panel) => { panel.hidden = true; });
        const emptyState = this.querySelector('[data-empty-state]');
        if (emptyState) emptyState.hidden = false;
      }

      selectProduct(key) {
        this.activeProductKey = key;
        const emptyState = this.querySelector('[data-empty-state]');
        if (emptyState) emptyState.hidden = true;
        let activeTab = null;
        this.productTabs.forEach((tab) => {
          const active = tab.dataset.productKey === key;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active) activeTab = tab;
        });
        const selectedName = this.querySelector('[data-mobile-selected-name]');
        if (selectedName) selectedName.textContent = activeTab?.dataset.productName || '';
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.productKey !== key; });
      }

      alignProductToStart(tab) {
        const productList = this.querySelector('[data-product-list]');
        if (!productList || !tab || !this.mobileQuery.matches) return;
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          productList.scrollTo({ left: Math.max(0, tab.offsetLeft), behavior: 'auto' });
        });
      }

      alignCardListToStart(productList) {
        if (!productList || !this.mobileQuery.matches) return;
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          productList.scrollTo({ left: 0, behavior: 'auto' });
          requestAnimationFrame(() => {
            if (this.isConnected) productList.scrollTo({ left: 0, behavior: 'auto' });
          });
        });
      }

      revealCategoryControl(control) {
        if (!control || !this.mobileQuery.matches) return;
        const scroller = control.parentElement;
        if (!scroller) return;
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const scrollerRect = scroller.getBoundingClientRect();
          const controlRect = control.getBoundingClientRect();
          const inset = 4;
          let delta = 0;
          if (controlRect.left < scrollerRect.left + inset) delta = controlRect.left - scrollerRect.left - inset;
          else if (controlRect.right > scrollerRect.right - inset) delta = controlRect.right - scrollerRect.right + inset;
          if (delta !== 0) scroller.scrollTo({ left: Math.max(0, scroller.scrollLeft + delta), behavior: 'auto' });
        });
      }
    }

    customElements.define('ff-shop-categories-v4', FFShopCategoriesV4);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-home-sup-intro-v1-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ff-sup-intro')) return;

    class FfSupIntro extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 860px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.syncVideos = this.syncVideos.bind(this);
        this.mobileQuery.addEventListener('change', this.syncVideos);
        this.reducedMotionQuery.addEventListener('change', this.syncVideos);
        document.addEventListener('visibilitychange', this.syncVideos);
        this.syncVideos();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.syncVideos);
        this.reducedMotionQuery?.removeEventListener('change', this.syncVideos);
        document.removeEventListener('visibilitychange', this.syncVideos);
      }

      syncVideos() {
        const isMobile = this.mobileQuery.matches;
        const shouldReduceMotion = this.reducedMotionQuery.matches;

        this.querySelectorAll('video').forEach((video) => {
          const asset = video.closest('.ff-sup__media-asset');
          const isMobileAsset = asset?.classList.contains('ff-sup__media-asset--mobile');
          const isVisibleAsset = isMobile === isMobileAsset;
          const shouldAutoplay = video.hasAttribute('autoplay') && isVisibleAsset && !shouldReduceMotion && !document.hidden;

          if (shouldAutoplay) {
            video.play().catch(() => {});
          } else if (!isVisibleAsset || shouldReduceMotion || document.hidden) {
            video.pause();
          }
        });
      }
    }

    customElements.define('ff-sup-intro', FfSupIntro);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-home-technology-v4"] && !Shopify.designMode) return;
  try {
    
customElements.get("ff-tech-v4")||customElements.define("ff-tech-v4",class extends HTMLElement{connectedCallback(){var i;(i=this.abortController)==null||i.abort(),this.removeMotionMediaListeners(),this.resetMotion(),this.abortController=new AbortController,this.tabs=Array.from(this.querySelectorAll('[role="tab"][data-index]')),this.panel=this.querySelector('[role="tabpanel"]'),this.titleTarget=this.querySelector("[data-detail-title]"),this.copyTarget=this.querySelector("[data-detail-copy]"),this.motionStage=this.querySelector(".ff-tcv4__stage--2a"),this.motionViewport=window.matchMedia("(min-width: 768px)"),this.motionPreference=window.matchMedia("(prefers-reduced-motion: reduce)"),this.onMotionMediaChange=()=>this.configureMotion();const t=this.querySelector("[data-callout-data]");try{this.details=t?JSON.parse(t.textContent):[]}catch(e){this.details=[]}this.tabs.forEach((e,o)=>{e.addEventListener("click",()=>this.activate(o,!1),{signal:this.abortController.signal}),e.addEventListener("keydown",n=>this.onKeydown(n,o),{signal:this.abortController.signal})}),this.addEventListener("shopify:block:select",e=>{const o=e.target.closest("[data-callout]");o&&this.activate(Number(o.dataset.callout),!1)},{signal:this.abortController.signal}),this.motionViewport.addEventListener("change",this.onMotionMediaChange),this.motionPreference.addEventListener("change",this.onMotionMediaChange),this.configureMotion()}disconnectedCallback(){var t;(t=this.abortController)==null||t.abort(),this.removeMotionMediaListeners(),this.resetMotion()}removeMotionMediaListeners(){var t,i;this.onMotionMediaChange&&((t=this.motionViewport)==null||t.removeEventListener("change",this.onMotionMediaChange),(i=this.motionPreference)==null||i.removeEventListener("change",this.onMotionMediaChange),this.onMotionMediaChange=null)}configureMotion(){if(!(!this.motionStage||this.dataset.layout!=="2a")){if(this.motionPreference.matches){this.dataset.motionPlayed="true",this.resetMotion();return}if(!this.motionViewport.matches||this.dataset.motionPlayed==="true"){this.resetMotion();return}this.prepareMotion()}}prepareMotion(){if(this.classList.contains("ff-tcv4--motion-ready"))return;if(!("IntersectionObserver"in window)){this.dataset.motionPlayed="true";return}this.classList.add("ff-tcv4--motion-ready");const t=window.innerHeight||document.documentElement.clientHeight||800,i=Math.max(this.motionStage.getBoundingClientRect().height,1),e=Math.max(.01,Math.min(.25,t*.4/i));this.motionObserver=new IntersectionObserver(o=>{o.some(n=>n.isIntersecting)&&this.isMotionVisible()&&this.playMotion()},{threshold:[0,e]}),this.motionObserver.observe(this.motionStage),this.motionFrame=window.requestAnimationFrame(()=>{this.motionFrame=null,this.isMotionVisible()&&this.playMotion()})}isMotionVisible(){if(!this.motionStage)return!1;const t=this.motionStage.getBoundingClientRect();if(t.height<=0)return!1;const i=window.innerHeight||document.documentElement.clientHeight||800,e=Math.min(t.bottom,i)-Math.max(t.top,0),o=Math.min(t.height*.25,i*.4);return e>=o}playMotion(){var t;this.dataset.motionPlayed!=="true"&&(this.dataset.motionPlayed="true",(t=this.motionObserver)==null||t.disconnect(),this.motionObserver=null,this.motionFrame!==null&&this.motionFrame!==void 0&&window.cancelAnimationFrame(this.motionFrame),this.motionFrame=window.requestAnimationFrame(()=>{this.motionFrame=null,this.isConnected&&(this.classList.add("ff-tcv4--motion-revealed"),this.motionCompletionTimer=window.setTimeout(()=>this.resetMotion(),1520))}))}resetMotion(){var t;(t=this.motionObserver)==null||t.disconnect(),this.motionObserver=null,this.motionFrame!==null&&this.motionFrame!==void 0&&window.cancelAnimationFrame(this.motionFrame),this.motionFrame=null,this.motionCompletionTimer!==null&&this.motionCompletionTimer!==void 0&&window.clearTimeout(this.motionCompletionTimer),this.motionCompletionTimer=null,this.classList.remove("ff-tcv4--motion-ready","ff-tcv4--motion-revealed")}activate(t,i){if(!this.tabs.length||!this.details[t])return;const e=this.details[t];this.tabs.forEach((o,n)=>{const s=n===t;o.setAttribute("aria-selected",String(s)),o.tabIndex=s?0:-1}),this.panel&&this.panel.setAttribute("aria-labelledby",e.tabId),this.titleTarget&&(this.titleTarget.textContent=e.title),this.copyTarget&&(this.copyTarget.textContent=e.copy),i&&this.tabs[t].focus()}onKeydown(t,i){if(!["ArrowLeft","ArrowRight","Home","End"].includes(t.key))return;t.preventDefault();let e=i;t.key==="Home"?e=0:t.key==="End"?e=this.tabs.length-1:e=(i+(t.key==="ArrowRight"?1:-1)+this.tabs.length)%this.tabs.length,this.activate(e,!0)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-10a"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-quiz]').forEach(function(root){
    if(root.dataset.ffInit) return; root.dataset.ffInit='1';
    var dataEl=root.querySelector('.quiz-data'); if(!dataEl) return;
    var cfg; try{ cfg=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var QUIZ=cfg.questions||[], RESULTS=cfg.results||[], BOARD_IMG=cfg.boardImg||'', L=cfg.labels||{}, W=cfg.weights||[3,1,1,2];
    var mount=root.querySelector('.quiz-mount'); if(!mount || !QUIZ.length || !RESULTS.length) return;
    // Default match profiles by result index, tuned for the standard
    // journey / break / priority / build question order. Used only when a
    // result has no explicit match set, so Q2-Q4 count out of the box.
    var DEFAULT_MATCH=[[2,3,2,2],[1,1,1,3],[3,2,2,1],[4,4,4,4]];
    var step=0, answers=new Array(QUIZ.length).fill(null);
    function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
    function matchFor(r,i){ var m=r.match||[]; for(var k=0;k<m.length;k++){ if(m[k]>0) return m; } return DEFAULT_MATCH[i]||[]; }
    function bestResult(){
      var best=0, bs=-1;
      for(var b=0;b<RESULTS.length;b++){
        var m=matchFor(RESULTS[b],b), s=0;
        for(var q=0;q<answers.length;q++){ if(answers[q]==null) continue; if(m[q] && (answers[q]+1)===m[q]) s+=(W[q]||1); }
        if(s>bs){ bs=s; best=b; }
      }
      return RESULTS[best]||RESULTS[0];
    }
    function render(){
      var q=QUIZ[step];
      var dots=QUIZ.map(function(_,i){return '<i class="'+(i<=step?'on':'')+'"></i>';}).join('');
      var opts=(q.opts||[]).filter(function(o){return o && o.length;}).map(function(o,i){return '<button class="opt" data-i="'+i+'" aria-pressed="'+(answers[step]===i)+'"><span class="dot"></span>'+esc(o)+'</button>';}).join('');
      mount.innerHTML='<div class="qprog"><span style="width:'+(((step+1)/QUIZ.length)*100)+'%"></span></div><div class="dots">'+dots+'</div><div class="qstep">'+esc((L.qof||'Question {n} of {t}').replace('{n}',step+1).replace('{t}',QUIZ.length))+'</div><h4 class="qtitle">'+esc(q.q)+'</h4><div class="opts">'+opts+'</div><div class="qnav"><button class="ff-btn ff-btn--ghost ff-btn--sm" data-back '+(step===0?'disabled style="opacity:.4;pointer-events:none;"':'')+'>'+esc(L.back||'Back')+'</button><button class="ff-btn ff-btn--sm" data-next style="flex:1;">'+esc(step===QUIZ.length-1?(L.see||'See my board'):(L.next||'Next question'))+'</button></div>';
      mount.querySelectorAll('.opt').forEach(function(b){ b.addEventListener('click',function(){ answers[step]=+b.dataset.i; mount.querySelectorAll('.opt').forEach(function(x){x.setAttribute('aria-pressed','false');}); b.setAttribute('aria-pressed','true'); }); });
      mount.querySelector('[data-next]').addEventListener('click',function(){ if(answers[step]===null){ mount.querySelector('.qtitle').style.color='#D04949'; return; } if(step===QUIZ.length-1){ showResult(); } else { step++; render(); } });
      var back=mount.querySelector('[data-back]'); if(back) back.addEventListener('click',function(){ if(step>0){ step--; render(); } });
    }
    function showResult(){
      var r=bestResult(); var img=(r.img&&r.img.length)?r.img:BOARD_IMG; var link=(r.url&&r.url.length&&r.url!=='#')?r.url:(cfg.shopLink||'#');
      mount.innerHTML='<div class="result"><div class="rl">'+esc(L.match||'Your match')+'</div>'+(img?'<img src="'+img+'" alt="'+esc(r.name)+'">':'')+'<div class="rn">'+esc(r.name)+'</div><div class="rd">'+esc(r.desc)+'</div><div class="qnav"><a class="ff-btn ff-btn--sm" href="'+link+'" style="flex:1;">'+esc(L.shop||'Shop this board')+'</a><button class="ff-btn ff-btn--ghost ff-btn--sm" data-restart>'+esc(L.restart||'Start over')+'</button></div></div>';
      mount.querySelector('[data-restart]').addEventListener('click',function(){ step=0; answers.fill(null); render(); });
    }
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-10b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-quiz]').forEach(function(root){
    if(root.dataset.ffInit) return; root.dataset.ffInit='1';
    var dataEl=root.querySelector('.quiz-data'); if(!dataEl) return;
    var cfg; try{ cfg=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var QUIZ=cfg.questions||[], RESULTS=cfg.results||[], BOARD_IMG=cfg.boardImg||'', L=cfg.labels||{}, W=cfg.weights||[3,1,1,2];
    var mount=root.querySelector('.quiz-mount'); if(!mount || !QUIZ.length || !RESULTS.length) return;
    var DEFAULT_MATCH=[[2,3,2,2],[1,1,1,3],[3,2,2,1],[4,4,4,4]];
    var step=0, answers=new Array(QUIZ.length).fill(null);
    function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
    function matchFor(r,i){ var m=r.match||[]; for(var k=0;k<m.length;k++){ if(m[k]>0) return m; } return DEFAULT_MATCH[i]||[]; }
    function bestResult(){
      var best=0, bs=-1;
      for(var b=0;b<RESULTS.length;b++){
        var m=matchFor(RESULTS[b],b), s=0;
        for(var q=0;q<answers.length;q++){ if(answers[q]==null) continue; if(m[q] && (answers[q]+1)===m[q]) s+=(W[q]||1); }
        if(s>bs){ bs=s; best=b; }
      }
      return RESULTS[best]||RESULTS[0];
    }
    function render(){
      var q=QUIZ[step];
      var dots=QUIZ.map(function(_,i){return '<i class="'+(i<=step?'on':'')+'"></i>';}).join('');
      var opts=(q.opts||[]).filter(function(o){return o && o.length;}).map(function(o,i){return '<button class="opt" data-i="'+i+'" aria-pressed="'+(answers[step]===i)+'"><span class="dot"></span>'+esc(o)+'</button>';}).join('');
      mount.innerHTML='<div class="qprog"><span style="width:'+(((step+1)/QUIZ.length)*100)+'%"></span></div><div class="dots">'+dots+'</div><div class="qstep">'+esc((L.qof||'Question {n} of {t}').replace('{n}',step+1).replace('{t}',QUIZ.length))+'</div><h4 class="qtitle">'+esc(q.q)+'</h4><div class="opts">'+opts+'</div><div class="qnav"><button class="ff-btn ff-btn--ghost ff-btn--sm" data-back '+(step===0?'disabled style="opacity:.4;pointer-events:none;"':'')+'>'+esc(L.back||'Back')+'</button><button class="ff-btn ff-btn--sm" data-next style="flex:1;">'+esc(step===QUIZ.length-1?(L.see||'See my board'):(L.next||'Next question'))+'</button></div>';
      mount.querySelectorAll('.opt').forEach(function(b){ b.addEventListener('click',function(){ answers[step]=+b.dataset.i; mount.querySelectorAll('.opt').forEach(function(x){x.setAttribute('aria-pressed','false');}); b.setAttribute('aria-pressed','true'); }); });
      mount.querySelector('[data-next]').addEventListener('click',function(){ if(answers[step]===null){ mount.querySelector('.qtitle').style.color='#D04949'; return; } if(step===QUIZ.length-1){ showResult(); } else { step++; render(); } });
      var back=mount.querySelector('[data-back]'); if(back) back.addEventListener('click',function(){ if(step>0){ step--; render(); } });
    }
    function showResult(){
      var r=bestResult(); var img=(r.img&&r.img.length)?r.img:BOARD_IMG; var link=(r.url&&r.url.length&&r.url!=='#')?r.url:(cfg.shopLink||'#');
      mount.innerHTML='<div class="result"><div class="rl">'+esc(L.match||'Your match')+'</div>'+(img?'<img src="'+img+'" alt="'+esc(r.name)+'">':'')+'<div class="rn">'+esc(r.name)+'</div><div class="rd">'+esc(r.desc)+'</div><div class="qnav"><a class="ff-btn ff-btn--sm" href="'+link+'" style="flex:1;">'+esc(L.shop||'Shop this board')+'</a><button class="ff-btn ff-btn--ghost ff-btn--sm" data-restart>'+esc(L.restart||'Start over')+'</button></div></div>';
      mount.querySelector('[data-restart]').addEventListener('click',function(){ step=0; answers.fill(null); render(); });
    }
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-10c"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-quizc]').forEach(function(root){
    var dataEl=root.querySelector('.quiz-data'); if(!dataEl) return;
    var cfg; try{ cfg=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var QUIZ=cfg.questions||[], RESULTS=cfg.results||[], BOARD_IMG=cfg.boardImg||'', L=cfg.labels||{}, W=cfg.weights||[3,2,1,1], PICKQS=cfg.pickQs||[1,3];
    var mount=root.querySelector('.quiz-mount'); if(!mount || !QUIZ.length || !RESULTS.length) return;
    var step=0, answers=new Array(QUIZ.length).fill(null);
    function esc(s){ var d=document.createElement('div'); d.textContent=s==null?'':s; return d.innerHTML; }
    function bestResult(){
      var best=0, bs=-1;
      for(var b=0;b<RESULTS.length;b++){
        var m=RESULTS[b].match||[], s=0;
        for(var q=0;q<answers.length;q++){ if(answers[q]==null) continue; if(m[q] && (answers[q]+1)===m[q]) s+=(W[q]||1); }
        if(s>bs){ bs=s; best=b; }
      }
      return RESULTS[best]||RESULTS[0];
    }
    function render(){
      var q=QUIZ[step];
      var dots=QUIZ.map(function(_,i){return '<i class="'+(i<=step?'on':'')+'"></i>';}).join('');
      var opts=(q.opts||[]).filter(function(o){return o && o.length;}).map(function(o,i){return '<button class="opt" data-i="'+i+'" aria-pressed="'+(answers[step]===i)+'"><span class="dot"></span>'+esc(o)+'</button>';}).join('');
      mount.innerHTML='<div class="qprog"><span style="width:'+(((step+1)/QUIZ.length)*100)+'%"></span></div><div class="dots">'+dots+'</div><div class="qstep">'+esc((L.qof||'Question {n} of {t}').replace('{n}',step+1).replace('{t}',QUIZ.length))+'</div><h4 class="qtitle">'+esc(q.q)+'</h4><div class="opts">'+opts+'</div><div class="qnav"><button class="ff-btn ff-btn--ghost ff-btn--sm" data-back '+(step===0?'disabled style="opacity:.4;pointer-events:none;"':'')+'>'+esc(L.back||'Back')+'</button><button class="ff-btn ff-btn--sm" data-next style="flex:1;">'+esc(step===QUIZ.length-1?(L.see||'See my board'):(L.next||'Next question'))+'</button></div>';
      mount.querySelectorAll('.opt').forEach(function(b){ b.addEventListener('click',function(){ answers[step]=+b.dataset.i; mount.querySelectorAll('.opt').forEach(function(x){x.setAttribute('aria-pressed','false');}); b.setAttribute('aria-pressed','true'); }); });
      mount.querySelector('[data-next]').addEventListener('click',function(){ if(answers[step]===null){ mount.querySelector('.qtitle').style.color='#D04949'; return; } if(step===QUIZ.length-1){ showResult(); } else { step++; render(); } });
      var back=mount.querySelector('[data-back]'); if(back) back.addEventListener('click',function(){ if(step>0){ step--; render(); } });
    }
    function pickPills(){
      var pills=[];
      PICKQS.forEach(function(qn){ var qi=qn-1; if(qi>=0 && QUIZ[qi] && answers[qi]!=null){ var t=(QUIZ[qi].opts||[])[answers[qi]]; if(t) pills.push('<span class="pick">'+esc(t)+'</span>'); } });
      return pills.length ? '<div class="rpicks">'+esc(L.picks||'Your picks')+': '+pills.join('')+'</div>' : '';
    }
    function showResult(){
      var r=bestResult(); var img=(r.img&&r.img.length)?r.img:BOARD_IMG; var link=(r.url&&r.url!=='#')?r.url:(cfg.shopLink||'#');
      var reasonHtml = (r.reason&&r.reason.length) ? '<p class="rreason">'+esc(r.reason)+'</p>' : ((r.desc&&r.desc.length)?'<div class="rd">'+esc(r.desc)+'</div>':'');
      var tags=[];
      if(r.proof&&r.proof.length) tags.push('<span class="rtag rtag--proof">'+esc(r.proof)+'</span>');
      if(r.value&&r.value.length) tags.push('<span class="rtag rtag--value">'+esc(r.value)+'</span>');
      var tagsHtml = tags.length ? '<div class="rtags">'+tags.join('')+'</div>' : '';
      mount.innerHTML='<div class="result"><div class="rl">'+esc(L.match||'Your match')+'</div>'+(img?'<img src="'+img+'" alt="'+esc(r.name)+'">':'')+'<div class="rn">'+esc(r.name)+'</div>'+pickPills()+reasonHtml+tagsHtml+'<div class="qnav"><a class="ff-btn ff-btn--sm" href="'+link+'" style="flex:1;">'+esc(L.shop||'Shop this board')+'</a><button class="ff-btn ff-btn--ghost ff-btn--sm" data-restart>'+esc(L.restart||'Start over')+'</button></div></div>';
      mount.querySelector('[data-restart]').addEventListener('click',function(){ step=0; answers.fill(null); render(); });
    }
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-11a"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-anat]').forEach(function(anat){
    var dataEl=anat.querySelector('.anat-data'); var FEATURES=[];
    if(dataEl){ try{ FEATURES=JSON.parse(dataEl.textContent); }catch(e){} }
    var detail=anat.querySelector('[data-detail]');
    function activate(idx){
      var f=FEATURES[idx]; if(!f||!detail) return;
      anat.querySelectorAll('[data-feat]').forEach(function(el){ el.setAttribute('aria-selected', el.dataset.idx===String(idx)?'true':'false'); });
      var lb=detail.querySelector('.lb'), h=detail.querySelector('h4'), p=detail.querySelector('p');
      if(lb) lb.textContent=f.lb; if(h) h.textContent=f.title; if(p) p.textContent=f.desc;
    }
    anat.querySelectorAll('[data-feat]').forEach(function(el){ el.addEventListener('click',function(){ activate(+el.dataset.idx); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-11b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-stack]').forEach(function(stack){
    stack.querySelectorAll('.layer').forEach(function(l){ l.addEventListener('click',function(){
      stack.querySelectorAll('.layer').forEach(function(x){x.setAttribute('aria-selected','false');}); l.setAttribute('aria-selected','true');
    }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-2a"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-shop]').forEach(function(shop){
    var DIMS = {
      shape: JSON.parse(shop.getAttribute('data-shape-opts') || '[["all","All"],["long","Longboard"],["fun","Funboard"],["short","Shortboard"]]'),
      brand: JSON.parse(shop.getAttribute('data-brand-opts') || '[["all","All"],["formula-fun","Formula Fun"],["album","Album"]]'),
      skill: JSON.parse(shop.getAttribute('data-skill-opts') || '[["all","All"],["beginner","Beginner"],["advanced","Advanced"]]')
    };
    var parentBtns = shop.querySelectorAll('.shop-parent button');
    var seg = shop.querySelector('[data-sub]');
    var cards = shop.querySelectorAll('.card');
    var dim = 'shape';
    function applyFilter(val){ cards.forEach(function(c){ c.style.display = (val==='all'||c.dataset[dim]===val) ? '' : 'none'; }); }
    function buildSub(){
      seg.innerHTML = DIMS[dim].map(function(o,i){ return '<button role="tab" data-val="'+o[0]+'" aria-selected="'+(i===0?'true':'false')+'">'+o[1]+'</button>'; }).join('');
      seg.querySelectorAll('button').forEach(function(b){ b.addEventListener('click', function(){
        seg.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-selected','false'); });
        b.setAttribute('aria-selected','true'); applyFilter(b.dataset.val);
      }); });
      applyFilter('all');
    }
    parentBtns.forEach(function(p){ p.addEventListener('click', function(){
      parentBtns.forEach(function(x){ x.setAttribute('aria-selected','false'); });
      p.setAttribute('aria-selected','true'); dim = p.dataset.dim; buildSub();
    }); });
    buildSub();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-2b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-rail]').forEach(function(rail){
    var all=rail.querySelectorAll('.cats button');
    all.forEach(function(b){ b.addEventListener('click',function(){ all.forEach(function(x){x.setAttribute('aria-selected','false');}); b.setAttribute('aria-selected','true'); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-3a"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-bars]').forEach(function(el){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.querySelectorAll('[data-w]').forEach(function(s){s.style.width=s.dataset.w+'%';});io.unobserve(e.target);}});},{threshold:.25});
    io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-3b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-bars]').forEach(function(el){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.querySelectorAll('[data-w]').forEach(function(s){s.style.width=s.dataset.w+'%';});io.unobserve(e.target);}});},{threshold:.25});
    io.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-5a"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ff-vidtabs] .tabs').forEach(function(group){
    var btns=group.querySelectorAll('button');
    btns.forEach(function(b){ b.addEventListener('click',function(){ btns.forEach(function(x){x.setAttribute('aria-selected','false');}); b.setAttribute('aria-selected','true'); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-5b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ff-hp5b .vid .tabs').forEach(function(group){
    var btns=group.querySelectorAll('button');
    btns.forEach(function(b){ b.addEventListener('click',function(){ btns.forEach(function(x){x.setAttribute('aria-selected','false');}); b.setAttribute('aria-selected','true'); }); });
  });
  document.querySelectorAll('[data-ff-theatre]').forEach(function(t){
    var feat=t.querySelector('[data-feature]'); if(!feat) return;
    var fimg=feat.querySelector('img'), ft=feat.querySelector('[data-ftitle]'), fv=feat.querySelector('[data-fviews]');
    t.querySelectorAll('[data-vid]').forEach(function(li){ li.addEventListener('click',function(){
      t.querySelectorAll('[data-vid]').forEach(function(x){x.removeAttribute('aria-current');}); li.setAttribute('aria-current','true');
      if(fimg && li.dataset.img){fimg.src=li.dataset.img;} if(ft){ft.textContent=li.dataset.title;} if(fv){fv.textContent=li.dataset.views;}
    }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-9a"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-home-faq-a')) {
  customElements.define('ff-home-faq-a', class FFHomeFaqA extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const items = [...this.querySelectorAll('[data-faq-item]')];
      let openFound = false;

      items.forEach((item) => {
        if (this.dataset.singleOpen === 'true' && item.open) {
          if (openFound) item.open = false;
          openFound = true;
        }
        item.addEventListener('toggle', () => this.handleToggle(item), { signal });
      });

      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('[data-faq-item]');
        if (!item || !this.contains(item)) return;
        item.open = true;
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleToggle(activeItem) {
      if (!activeItem.open || this.dataset.singleOpen !== 'true') return;
      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        if (item !== activeItem) item.open = false;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hp-9b"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-home-faq-b')) {
  customElements.define('ff-home-faq-b', class FFHomeFaqB extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.dataset.enhanced = 'true';
      const items = [...this.querySelectorAll('[data-faq-item]')];
      let openFound = false;

      items.forEach((item) => {
        if (this.dataset.singleOpen === 'true' && item.open) {
          if (openFound) item.open = false;
          openFound = true;
        }
        item.addEventListener('toggle', () => this.handleToggle(item), { signal });
      });

      this.querySelectorAll('.ff-hp9b__chips button').forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button), { signal });
      });

      const preferred = this.querySelector(`.ff-hp9b__chips [data-cat="${CSS.escape(this.dataset.defaultCategory || 'all')}"]`);
      const initial = preferred || this.querySelector('.ff-hp9b__chips [data-cat="all"]') || this.querySelector('.ff-hp9b__chips button');
      if (initial) this.applyFilter(initial);

      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('[data-faq-item]');
        if (!item || !this.contains(item)) return;
        const categoryButton = this.querySelector(`.ff-hp9b__chips [data-cat="${CSS.escape(item.dataset.cat)}"]`);
        if (categoryButton) this.applyFilter(categoryButton);
        item.hidden = false;
        item.open = true;
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleToggle(activeItem) {
      if (!activeItem.open || this.dataset.singleOpen !== 'true') return;
      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        if (item !== activeItem) item.open = false;
      });
    }

    applyFilter(activeButton) {
      this.querySelectorAll('.ff-hp9b__chips button').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === activeButton));
      });
      const category = activeButton.dataset.cat;
      let visibleCount = 0;
      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        const visible = category === 'all' || item.dataset.cat === category;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      const status = this.querySelector('[data-filter-status]');
      if (status) status.textContent = `${visibleCount} ${this.dataset.statusLabel}`.trim();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v3-blog-grid"] && !Shopify.designMode) return;
  try {
    
let ffV3CurrentCategory = 'all';

window.ffV3FilterCategory = function(cat) {
  ffV3CurrentCategory = cat;

  document.querySelectorAll('.ff-v3-grid-v4__tab, .ff-v3-shelves-v4__pill').forEach(tab => {
    const isMatch = tab.getAttribute('data-cat') === cat;
    tab.classList.toggle('is-active', isMatch);
    tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    tab.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
  });

  ffV3ApplyFilters();

  const gridElem = document.getElementById('ff-v3-grid-section');
  if (gridElem) {
    const rect = gridElem.getBoundingClientRect();
    if (rect.top < -100 || rect.top > 500) {
      gridElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
};

function ffV3ApplyFilters() {
  const searchInput = document.getElementById('ff-v3-search-input');
  const query = (searchInput ? searchInput.value : '').toLowerCase().trim();
  const cards = document.querySelectorAll('.ff-v3-article-card-v4');
  let visible = 0;

  cards.forEach(card => {
    const cardCat = card.getAttribute('data-category');
    const title = (card.querySelector('.ff-v3-article-card-v4__title')?.textContent || '').toLowerCase();
    const excerpt = (card.querySelector('.ff-v3-article-card-v4__excerpt')?.textContent || '').toLowerCase();

    const matchesCat = (ffV3CurrentCategory === 'all') || (cardCat === ffV3CurrentCategory);
    const matchesQuery = !query || title.includes(query) || excerpt.includes(query);

    if (matchesCat && matchesQuery) {
      card.style.display = 'flex';
      visible++;
    } else {
      card.style.display = 'none';
    }
  });

  const countElem = document.getElementById('ff-v3-visible-count');
  if (countElem) {
    countElem.textContent = visible;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('ff-v3-search-input');
  if (searchInput) {
    searchInput.addEventListener('input', ffV3ApplyFilters);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-about-origin-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ff-origin-video')) return;
    class FfOriginVideo extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.mobileQuery = window.matchMedia('(max-width: 900px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.controller.signal };
        this.mobileQuery.addEventListener('change', () => this.syncVideos(), options);
        this.reducedMotionQuery.addEventListener('change', () => this.syncVideos(), options);
        document.addEventListener('visibilitychange', () => this.syncVideos(), options);
        this.iframeObserver = new MutationObserver(() => this.syncIframeTitles());
        this.iframeObserver.observe(this, { attributes: true, attributeFilter: ['title'], subtree: true });
        this.syncIframeTitles();
        this.syncVideos();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.iframeObserver?.disconnect();
      }
      syncIframeTitles() {
        this.querySelectorAll('iframe[data-ff-title]').forEach((iframe) => {
          const intendedTitle = iframe.dataset.ffTitle;
          if (intendedTitle && iframe.title !== intendedTitle) iframe.title = intendedTitle;
        });
      }
      syncVideos() {
        const isMobile = this.mobileQuery.matches;
        const reduceMotion = this.reducedMotionQuery.matches;
        this.querySelectorAll('video').forEach((video) => {
          const asset = video.closest('.ffv5-abvideo__asset');
          const shared = video.closest('.ffv5-abvideo__media')?.classList.contains('ffv5-abvideo__media--shared');
          const isMobileAsset = asset?.classList.contains('ffv5-abvideo__asset--mobile');
          const isVisible = shared || isMobile === isMobileAsset;
          const shouldPlay = video.hasAttribute('autoplay') && isVisible && !reduceMotion && !document.hidden;
          if (shouldPlay) video.play().catch(() => {});
          else video.pause();
        });
      }
    }
    customElements.define('ff-origin-video', FfOriginVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-faq-help-center"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffv5-faq]').forEach(function(root){
  var chips = root.querySelectorAll('[data-faqchips] button');
  var groups = root.querySelectorAll('[data-group]');
  var input = root.querySelector('[data-faqsearch]');
  var noresult = root.querySelector('[data-noresult]');
  var cat = 'all';
  function apply(){
    var q = (input && input.value || '').trim().toLowerCase();
    var any = false;
    groups.forEach(function(g){
      var inCat = (cat === 'all' || g.getAttribute('data-group') === cat);
      var groupHasMatch = false;
      g.querySelectorAll('details').forEach(function(d){
        var match = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
        d.classList.toggle('ffv5-faq__hidden', !(inCat && match));
        if (inCat && match) groupHasMatch = true;
      });
      g.classList.toggle('ffv5-faq__hidden', !(inCat && groupHasMatch));
      if (inCat && groupHasMatch) any = true;
    });
    if (noresult) noresult.classList.toggle('ffv5-faq__hidden', any);
  }
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      chips.forEach(function(x){ x.setAttribute('aria-selected', String(x === c)); });
      cat = c.dataset.cat;
      apply();
    });
  });
  if (input) input.addEventListener('input', apply);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-pdp-buy-doho"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffv5-pdpbuy]').forEach(function(root){
  var main = root.querySelector('[data-mainimg]');
  var thumbs = root.querySelectorAll('[data-thumbs] button');
  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.setAttribute('aria-selected', String(x === b)); });
      if (main) main.src = b.dataset.src;
      b.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
  });
  var colors = root.querySelectorAll('[data-colors] button');
  var variantInput = root.querySelector('[data-variant-input]');
  var priceEls = root.querySelectorAll('.ffv5-pdpbuy__price, [data-atc-price]');
  var atc = root.querySelector('.ffv5-pdpbuy__atc');
  var atcLabel = root.querySelector('[data-atc-label]');
  var availableLabel = root.dataset.atcLabel || 'Add to cart';
  var soldoutLabel = root.dataset.soldoutLabel || 'Sold out';
  colors.forEach(function(b){
    b.addEventListener('click', function(){
      colors.forEach(function(x){ x.setAttribute('aria-selected', String(x === b)); });
      if (variantInput && b.dataset.variantId) variantInput.value = b.dataset.variantId;
      if (b.dataset.price) priceEls.forEach(function(p){ p.textContent = b.dataset.price; });
      if (main && b.dataset.image) main.src = b.dataset.image;
      var available = b.dataset.available === 'true';
      if (atc) atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = (available ? availableLabel : soldoutLabel) + ' · ';
      document.dispatchEvent(new CustomEvent('ff:doho-variant-changed', {
        detail: { variantId: b.dataset.variantId }
      }));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-pdp-buy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffv5-pdpbuy]').forEach(function(root){
  var main = root.querySelector('[data-mainimg]');
  var thumbs = root.querySelectorAll('[data-thumbs] button');
  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.setAttribute('aria-selected', String(x === b)); });
      if (main) main.src = b.dataset.src;
      b.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
  });
  var colors = root.querySelectorAll('[data-colors] button');
  var variantInput = root.querySelector('[data-variant-input]');
  var priceEls = root.querySelectorAll('.ffv5-pdpbuy__price, [data-atc-price]');
  var atc = root.querySelector('.ffv5-pdpbuy__atc');
  var atcLabel = root.querySelector('[data-atc-label]');
  var availableLabel = root.dataset.atcLabel || 'Add to cart';
  var soldoutLabel = root.dataset.soldoutLabel || 'Sold out';
  colors.forEach(function(b){
    b.addEventListener('click', function(){
      colors.forEach(function(x){ x.setAttribute('aria-selected', String(x === b)); });
      if (variantInput && b.dataset.variantId) variantInput.value = b.dataset.variantId;
      if (b.dataset.price) priceEls.forEach(function(p){ p.textContent = b.dataset.price; });
      if (main && b.dataset.image) main.src = b.dataset.image;
      var available = b.dataset.available === 'true';
      if (atc) atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = (available ? availableLabel : soldoutLabel) + ' · ';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-pdp-quiz"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffv5-quiz]').forEach(function(root){
  var QUIZ = Array.prototype.map.call(root.querySelectorAll('[data-quiz-q]'), function(s){ return JSON.parse(s.textContent); });
  var RESULTS = Array.prototype.map.call(root.querySelectorAll('[data-quiz-r]'), function(s){ return JSON.parse(s.textContent); });
  if (!QUIZ.length || !RESULTS.length) return;
  var ql = root.querySelector('[data-ql]');
  var stepEl = root.querySelector('[data-step]');
  var chips = root.querySelector('[data-chips]');
  var result = root.querySelector('[data-result]');
  var rn = root.querySelector('[data-rn]');
  var rd = root.querySelector('[data-rd]');
  var rimg = root.querySelector('[data-rimg]');
  var rlink = root.querySelector('[data-rlink]');
  var stepLabel = root.dataset.stepLabel;
  var ofLabel = root.dataset.ofLabel;
  var thisBoardLabel = root.dataset.thisBoardLabel;
  var matchLabel = root.dataset.matchLabel;
  var doneLabel = root.dataset.doneLabel;
  var restartLabel = root.dataset.restartLabel;
  var step = 0, first = 0;
  function render(){
    var q = QUIZ[step];
    ql.textContent = q.q;
    stepEl.textContent = stepLabel + ' ' + (step + 1) + ' ' + ofLabel + ' ' + QUIZ.length;
    chips.innerHTML = q.opts.map(function(o, i){ return '<button type="button" data-i="' + i + '">' + o + '</button>'; }).join('');
    chips.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        if (step === 0) first = +b.dataset.i;
        b.setAttribute('aria-pressed', 'true');
        setTimeout(function(){ if (step === QUIZ.length - 1) finish(); else { step++; render(); } }, 180);
      });
    });
    result.classList.remove('ffv5-pdpquiz__result--show');
  }
  function finish(){
    var r = RESULTS[first] || RESULTS[0];
    rn.textContent = r.name; rd.textContent = r.desc;
    rimg.src = r.img; rlink.href = r.url;
    rlink.textContent = r.url === '#' ? thisBoardLabel : rlink.textContent;
    ql.textContent = matchLabel; stepEl.textContent = doneLabel;
    chips.innerHTML = '';
    var restart = document.createElement('button');
    restart.type = 'button';
    restart.dataset.restart = '';
    restart.textContent = restartLabel;
    chips.appendChild(restart);
    restart.addEventListener('click', function(){ step = 0; first = 0; render(); });
    result.classList.add('ffv5-pdpquiz__result--show');
  }
  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-technology-anatomy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ffv5-anat]').forEach(function(root){
  var btns = root.querySelectorAll('[data-feat]');
  var panes = root.querySelectorAll('[data-pane]');
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      var i = b.dataset.idx;
      btns.forEach(function(x){ x.setAttribute('aria-selected', String(x.dataset.idx === i)); });
      panes.forEach(function(p){ p.classList.toggle('ffv5-tecanat__dpane--hidden', p.dataset.pane !== i); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-v5-videos-theatre"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (customElements.get('ff-videos-theatre')) return;

  class FFVideosTheatre extends HTMLElement {
    connectedCallback(){
      if (this._abortController) return;
      this._abortController = new AbortController();
      var signal = this._abortController.signal;
      this.player = this.querySelector('[data-player]');
      this.featureTitle = this.querySelector('[data-ftitle]');
      this.featureMeta = this.querySelector('[data-fsub]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.player) {
        this._playerTitle = this.player.getAttribute('title') || '';
        this._titleObserver = new MutationObserver(() => {
          if (this.player && this._playerTitle && this.player.getAttribute('title') !== this._playerTitle) {
            this.player.setAttribute('title', this._playerTitle);
          }
        });
        this._titleObserver.observe(this.player, { attributes: true, attributeFilter: ['title'] });
      }

      this.querySelectorAll('.ffv5-vtheatre__li').forEach((item) => {
        item.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !item.dataset.src) return;
          event.preventDefault();
          this.selectEpisode(item);
        }, { signal: signal });
        item.addEventListener('keydown', (event) => this.onEpisodeKeydown(event, item), { signal: signal });
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectGroup(tab), { signal: signal });
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, tab), { signal: signal });
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        var item = event.target.closest('.ffv5-vtheatre__li');
        if (!item) return;
        var panel = item.closest('[data-group-list]');
        var tab = this.tabs.find((candidate) => candidate.dataset.group === panel.dataset.groupList);
        if (tab) this.selectGroup(tab, false);
        this.selectEpisode(item, false);
      }, { signal: signal });

      var selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      if (selectedTab) this.selectGroup(selectedTab, false, true);
      else {
        var initialItem = this.querySelector('.ffv5-vtheatre__li[aria-current="true"]') || this.querySelector('.ffv5-vtheatre__li');
        if (initialItem) this.selectEpisode(initialItem, false, true);
      }
    }

    disconnectedCallback(){
      if (this._abortController) this._abortController.abort();
      if (this._titleObserver) this._titleObserver.disconnect();
      this._abortController = null;
      this._titleObserver = null;
    }

    selectGroup(tab, focusTab, preserveCurrent){
      this.tabs.forEach((candidate) => {
        var selected = candidate === tab;
        candidate.setAttribute('aria-selected', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
      });
      var activePanel = null;
      this.panels.forEach((panel) => {
        var selected = panel.dataset.groupList === tab.dataset.group;
        panel.hidden = !selected;
        if (selected) activePanel = panel;
      });
      if (activePanel) {
        var item = preserveCurrent ? activePanel.querySelector('[aria-current="true"]') : null;
        this.selectEpisode(item || activePanel.querySelector('.ffv5-vtheatre__li'), false, preserveCurrent);
      }
      if (focusTab) tab.focus();
    }

    selectEpisode(item, focusItem, preserveCurrent){
      if (!item) return;
      var panel = item.closest('[data-group-list]');
      var items = Array.from(panel.querySelectorAll('.ffv5-vtheatre__li'));
      this.querySelectorAll('.ffv5-vtheatre__li').forEach((candidate) => candidate.removeAttribute('aria-current'));
      item.setAttribute('aria-current', 'true');
      if (this.player && item.dataset.src && (this.player.src !== item.dataset.src || !preserveCurrent)) {
        this.player.src = item.dataset.src;
      }
      if (this.player) {
        this._playerTitle = item.dataset.playerTitle || item.dataset.title || this._playerTitle || this.player.title;
        this.player.title = this._playerTitle;
      }
      if (this.featureTitle) this.featureTitle.textContent = item.dataset.title || '';
      if (this.featureMeta) this.featureMeta.textContent = panel.dataset.label + ' · ' + this.dataset.episodeWord + ' ' + (items.indexOf(item) + 1);
      if (focusItem) item.focus();
    }

    onTabKeydown(event, tab){
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var index = this.tabs.indexOf(tab);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = this.tabs.length - 1;
      else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
      this.selectGroup(this.tabs[index], true);
    }

    onEpisodeKeydown(event, item){
      if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      var panel = item.closest('[data-group-list]');
      var items = Array.from(panel.querySelectorAll('.ffv5-vtheatre__li'));
      var index = items.indexOf(item);
      var previous = event.key === 'ArrowUp' || event.key === 'ArrowLeft';
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = items.length - 1;
      else index = (index + (previous ? -1 : 1) + items.length) % items.length;
      event.preventDefault();
      items[index].focus();
    }
  }

  customElements.define('ff-videos-theatre', FFVideosTheatre);
})();

  } catch(e) { console.error(e); }
})();
})();
